module.exports = __webpack_public_path__ + "img/loader.a21746f5.gif";